import { render, staticRenderFns } from "./ChatShareMenu.vue?vue&type=template&id=1ab89992"
import script from "./ChatShareMenu.vue?vue&type=script&lang=js"
export * from "./ChatShareMenu.vue?vue&type=script&lang=js"
import style0 from "./ChatShareMenu.vue?vue&type=style&index=0&id=1ab89992&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports